import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from './company';

export interface CompaniesStore {
  loaded$: Observable<boolean>;
  allCompanies$: Observable<Company[]>;
  init(): void;
  addCompany(company: Company): void;
  editCompany(company: Company): void;
  deleteCompany(company: Company): void;
  editOrAddSuccess(): Observable<unknown>;
}

export const COMPANIES_STORE = new InjectionToken<CompaniesStore>(
  'COMPANIES_STORE',
);
